import React, { useEffect, Fragment } from "react";
import { useAppContext } from "../../../libs/contextLib";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { AnnouncementService } from "../../../services/announcement";
import Grid from "@material-ui/core/Grid";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";
import ErrorLoadingPage from "../../errorPages/errorLoadingPage";
import AnnouncementDialog from "./announcementDialog";
import AlertDialog from "../../helperComponents/alertDialog";
import Toast from "../../helperComponents/toast";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  dataGridRoot: {
    height: "100vh",
    width: "100%",
  },
  dataGrid: {
    backgroundColor: "white",
  },
}));

function AnnouncementSchoolAdmin(props) {
  const classes = useStyles();
  const { currentUser } = useAppContext();

  //active announcement
  const [announcement, setAnnouncement] = React.useState({
    _id: "",
    title: "",
    body: "",
    status: "",
    organisation: "",
    createdBy: "",
  });

  //loaded announcements
  const [announcements, setAnnouncements] = React.useState([]);

  //current row selected
  const [selectedRowIndex, setSelectedRowIndex] = React.useState("");

  //operation type Save or Edit
  const [opType, setOpType] = React.useState("");

  //data is loading
  const [isDataLoading, setIsDataLoading] = React.useState(true);
  const [errorLoadingPage, setErrorLoadingPage] = React.useState(false);

  //announcement dialog
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);

  //toast options
  const [toastOptions, setToastOptions] = React.useState({
    open: false,
    message: "",
    duration: 6000,
  });

  //alert dialog
  const [alertDialogOptions, setAlertDialogOptions] = React.useState({
    open: false,
    title: "",
    message: "Delete this announcement?",
    cancelMessage: "Cancel",
    confirmMessage: "OK",
  });

  //rows for datagrid

  let rows = [];

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "_id", headerName: "_id", width: 120, hide: "true" },
    {
      field: "organisation",
      headerName: "Organisation",
      width: 120,
      hide: "true",
    },
    {
      field: "dateCreated",
      headerName: "Date",
      width: 120,
      renderCell: (params) => {
        return moment(params.row.dateCreated).format("DD/MM/YYYY");
      },
    },

    { field: "title", headerName: "Title", width: 130 },
    { field: "body", headerName: "Body", width: 200 },
    {
      field: "createdBy",
      headerName: "Created By",
      width: 200,
      renderCell: (params) => {
        return (
          params.row.createdBy.firstName + " " + params.row.createdBy.lastName
        );
      },
    },
    { field: "status", headerName: "Status", width: 130 },
    {
      field: "",
      headerName: "",
      disableClickEventBubbling: true,
      renderCell: (params) => {
        const onClick = (op) => {
          setAnnouncement(params.row);
          setSelectedRowIndex(params.row.id);
          op === "edit"
            ? handleOpenDialog()
            : handleConfirmDeleteAnnouncement();
          //return alert(JSON.stringify(thisRow, null, 4));
        };

        return (
          <div>
            <Tooltip title="Edit">
              <IconButton
                aria-label="edit"
                onClick={() => {
                  return onClick("edit");
                }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() => {
                  return onClick("delete");
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  //pre-load verify token
  useEffect(() => {
    if (props.startFetchData) {
      onLoad();
    }
  }, [props.startFetchData]);

  async function onLoad() {
    try {
      setAnnouncements(
        await AnnouncementService.getAnnouncementsByOrgId(
          currentUser.organisation.id
        )
      );
      setIsDataLoading(false);
    } catch (err) {
      setErrorLoadingPage(true);
    }
  }

  function loadRows() {
    let temp = [];
    announcements.forEach((announcement, index, anns) => {
      announcement["id"] = index;
      temp.push(announcement);
      //   temp.push({
      //     id: index,
      //     _id: report._id,
      //     dateCreated: moment(report.dateCreated).format("DD/MM/YYYY"),
      //     organisation: report.organisation._id,
      //     title: report.title,
      //     body: report.body,
      //     createdBy: report.createdBy,
      //     status: report.status,
      //   });
    });
    return temp;

    // let temp = [];
    // announcements.forEach((announcement, index, anns) => {
    //   temp.push({
    //     id: index,
    //     _id: announcement._id,
    //     dateCreated: moment(announcement.dateCreated).format("DD/MM/YYYY"),
    //     organisation: announcement.organisation._id,
    //     title: announcement.title,
    //     body: announcement.body,
    //     createdBy: announcement.createdBy,
    //     status: announcement.status,
    //   });
    // });
    // return temp;
  }

  function handleCreateAnnouncement() {
    setAnnouncement({
      _id: "",
      title: "",
      body: "",
      status: "",
      organisation: "",
      createdBy: "",
    });
    setOpType("add");
    setIsDialogOpen(true);
  }

  function handleCloseDialog() {
    setIsDialogOpen(false);
  }

  const handleOpenDialog = () => {
    setOpType("edit");
    setIsDialogOpen(true);
  };

  function handleOpenAlertDialog() {
    setAlertDialogOptions({ ...alertDialogOptions, open: true });
  }

  function handleCloseAlertDialog() {
    setAlertDialogOptions({ ...alertDialogOptions, open: false });
  }

  function handleConfirmDeleteAnnouncement() {
    handleOpenAlertDialog();
  }

  async function handleProceedDeleteAnnouncement() {
    setAlertDialogOptions({ ...alertDialogOptions, open: false });
    let temp = [...announcements];
    temp.splice(selectedRowIndex, 1);
    try {
      await AnnouncementService.deleteAnnouncementsByOrgIdAndAnnouncementId(
        currentUser.organisation.id,
        announcement._id
      );
      setAnnouncements(temp);
      setToastOptions({
        ...toastOptions,
        open: true,
        message: "Announcement Deleted",
      });
    } catch (err) {
      setToastOptions({
        ...toastOptions,
        open: true,
        message: "Error deleting announcement",
      });
    }
  }

  //toast
  const handleCloseToast = (e, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setToastOptions({ ...toastOptions, open: false });
  };

  //data grid
  function AnnouncementDataGrid(props) {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.dataGridRoot}>
          <DataGrid
            className={classes.dataGrid}
            rows={rows}
            columns={columns}
            pageSize={5}
            autoHeight={true}
            loading={isDataLoading}
            checkboxSelection
            {...props}
          />
        </Grid>
      </Grid>
    );
  }

  //assessment
  function announcementComponent(props) {
    return (
      <Fragment>
        <Toast
          toastOptions={toastOptions}
          handleCloseToast={handleCloseToast}
        />
        <AlertDialog
          alertDialogOptions={alertDialogOptions}
          handleClose={handleCloseAlertDialog}
          handleConfirm={handleProceedDeleteAnnouncement}
        />
        <div className={classes.root}>
          <Grid container spacing={3}>
            {/* <Grid item xs={12}>
              <Typography variant="h4" className={classes.textCenter}>
                Announcements
              </Typography>
            </Grid> */}
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleCreateAnnouncement}
              >
                Add Announcement
              </Button>
            </Grid>
            <Grid item xs={12}>
              <AnnouncementDialog
                isDialogOpen={isDialogOpen}
                announcement={announcement}
                setAnnouncement={setAnnouncement}
                announcements={announcements}
                setAnnouncements={setAnnouncements}
                selectedRowIndex={selectedRowIndex}
                setSelectedRowIndex={setSelectedRowIndex}
                handleCloseDialog={handleCloseDialog}
                opType={opType}
                setOpType={setOpType}
                toastOptions={toastOptions}
                setToastOptions={setToastOptions}
              />
            </Grid>
            {AnnouncementDataGrid()}
          </Grid>
        </div>
      </Fragment>
    );
  }

  if (!errorLoadingPage) {
    rows = loadRows();
    return announcementComponent();
  } else {
    return <ErrorLoadingPage />;
  }

  // if (announcementsLoaded) {
  //   rows = loadRows(announcements);
  //   return announcementComponent({ loading: isDataLoading });
  // } else if (isDataLoading & !errorLoadingPage) {
  //   return announcementComponent({ loading: isDataLoading });
  // } else {
  //   return <ErrorLoadingPage />;
  // }
}

export default AnnouncementSchoolAdmin;
